import { render, staticRenderFns } from "./Inboxes.vue?vue&type=template&id=60836933&"
import script from "./Inboxes.vue?vue&type=script&lang=js&"
export * from "./Inboxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports